// Anonymous teacher identifier (when not logged in). Persists in localStorage.
const STORAGE_KEY = "atomicedu_teacher_id";

const generateId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `t-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getAnonymousTeacherId = ({ create = true } = {}) => {
  if (typeof window === "undefined") return null;
  let id = window.localStorage.getItem(STORAGE_KEY);
  if (!id && create) {
    id = generateId();
    window.localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
};

export const clearAnonymousTeacherId = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
};

// Backwards-compatible export — code calling getTeacherId() still gets a valid id.
export const getTeacherId = () => getAnonymousTeacherId({ create: true });
